module.exports = "/_next/static/images/menu-category-list-none-cooking-4dc07ee3c4567c26a7f008b69929ec7c.jpg";